import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=0d5531a5&scoped=true"
import script from "./Credentials.vue?vue&type=script&lang=js"
export * from "./Credentials.vue?vue&type=script&lang=js"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=0d5531a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5531a5",
  null
  
)

export default component.exports